import StorageService from './storage.service';
import store from '../store';

const apiBaseUrl = () => {
  return import.meta.env.VITE_APP_API_URL;
};

const appBaseUrl = () => {
  return import.meta.env.VITE_APP_BASE_URL;
};

const googleClientId = () => {
  return import.meta.env.VITE_APP_GOOGLE_CLIENT_ID;
};

const linkedinClientId = () => {
  return import.meta.env.VITE_APP_LINKEDIN_CLIENT_ID;
};
const linkedinSecretId = () => {
  return import.meta.env.VITE_APP_LINKEDIN_CLIENT_SECRET_ID;
};
const linkedinRedirectUrl = () => {
  return import.meta.env.VITE_APP_LINKEDIN_REDIRECT_URI;
};

const appName = () => {
  return import.meta.env.VITE_APP_NAME || '';
};

const appVersion = () => {
  return import.meta.env.VITE_APP_VERSION || '';
};

const authorizationToken = () => {
  let _auth = StorageService.getObject('authUser');
  let _token = null;
  try {
    _token = _auth['token'];
  } catch {
    _token = null;
  }

  return 'Bearer ' + _token;
};

const authUser = () => {
  let _auth = StorageService.getObject('authUser');

  return _auth;
};

const IsLoginStatus = () => {
  const state = store.getState();
  if (state.auth != null && state.auth.user != null) {
    let status = false;
    if (state.auth.user) {
      status = true;
    }

    return status;
  }
  return false;
};

const shortenAddress = (_walletAddress) => {
  if (
    _walletAddress === undefined ||
    _walletAddress == null ||
    _walletAddress === ''
  ) {
    return 'NA';
  }
  return _walletAddress.slice(0, 5) + '...' + _walletAddress.slice(-4);
};

const primaryDomainBaseUrl = () => {
  return import.meta.env.VITE_APP_DOMAIN_URL;
};

const chatWootToken = () => {
  return import.meta.env.VITE_APP_CHATWOOT_WEBSITE_TOKEN;
};

const adminPlatformUserUrl = () => {
  return import.meta.env.VITE_APP_PLATFORM_USER_URL;
};

const turnstileSiteKey = () => {
  return import.meta.env.VITE_APP_TURNSTILE_SITE_KEY || '';
};

const configService = {
  apiBaseUrl,
  appBaseUrl,
  appName,
  appVersion,
  authorizationToken,
  authUser,
  chatWootToken,
  IsLoginStatus,
  googleClientId,
  linkedinClientId,
  linkedinSecretId,
  shortenAddress,
  linkedinRedirectUrl,
  adminPlatformUserUrl,
  primaryDomainBaseUrl,
  turnstileSiteKey,
};

export default configService;
